<template>
  <div class="sd-tool-bar no-select">
    <sd-tool-item v-for="item in data" :key="item.name" :data="item"> </sd-tool-item>
  </div>
</template>

<script>
import SdToolItem from './SdToolItem.vue'
export default {
  name: 'SdToolBar',
  components: { SdToolItem },
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style scoped>
/*
  工具条组件样式2
  @component SdToolBar2
*/
.sd-tool-bar {
  position: absolute;
  z-index: 10;
}
</style>